export default {
  state: {
    extraStop: {
      leg1: [],
      leg2: []
    }
  },
  mutations: {
    setExtraStopData (state, data) {
      let index = state.extraStop[data.leg].findIndex(x => x.id === data.id)
      if (index > -1) {
        for (let field in data.fields) {
          state.extraStop[data.leg][index][field] = data.fields[field]
        }
      }
    },
    addExtraStop (state, data) {
      state.extraStop[data.leg].push(data.value)
    },
    removeExtraStop (state, data) {
      let index = state.extraStop[data.leg].findIndex(x => x.id === data.id)
      if (index > -1) {
        state.extraStop[data.leg].splice(index, 1)
      }
    },
    removeAllExtraStop (state, leg) {
      state.extraStop[leg] = []
    },
    setExtraStopLocationData (state, data) {
      let index = state.extraStop[data.leg].findIndex(x => x.id === data.id)
      if (index > -1) {
        state.extraStop[data.leg][index].location = data.value
      }
    },
    prependExtraStop (state, data) {
      state.extraStop[data.leg].unshift(data.value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/extra-stop.js